export interface IPills {
  id: number;
  contains: string[];
  available: string[];
  line: boolean;
  profile: boolean;
  categoryId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
}

export interface IUpdatePills {
  message: string;
}

export interface IBodyPills {
  contains: string[];
}

export enum EXCLUDE_PILL {
  Gama = 'Gama',
  Cargo = 'Cargo',
  Perfil = 'Perfil',
  'Perfil 1' = 'Perfil 1',
  'Perfil 2' = 'Perfil 2',
  'Perfil 3' = 'Perfil 3',
  'Perfil 4' = 'Perfil 4',
  'Perfil 5' = 'Perfil 5',
  Ancho = 'Ancho',
  Largo = 'Largo'
}

export enum EXCLUDED_PILLS {
  RANGE = 'Gama',
  ROLE = 'Cargo',
  PROFILE = 'Perfil',
  WIDTH = 'Ancho',
  LENGTH = 'Largo'
}

export interface ObjectKey<T> {
  [key: string]: T;
}
export interface IFormatPills {
  pillsList: ObjectKey<string>;
  excludeItems?: string[];
}
export interface IPillsAndProfiles {
  pills: IFormatPills[] | undefined;
  profiles: IFormatPills[] | undefined;
}
